var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpArrowUpBold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3635 5.29246C14.1759 5.10499 13.9216 4.99968 13.6565 4.99968C13.3913 4.99968 13.137 5.10499 12.9495 5.29246L7.99946 10.2425L3.04946 5.29246C2.86086 5.11031 2.60826 5.00951 2.34606 5.01179C2.08387 5.01407 1.83305 5.11924 1.64764 5.30465C1.46224 5.49005 1.35707 5.74087 1.35479 6.00306C1.35251 6.26526 1.45331 6.51786 1.63546 6.70646L7.29246 12.3635C7.47999 12.5509 7.7343 12.6562 7.99946 12.6562C8.26463 12.6562 8.51894 12.5509 8.70646 12.3635L14.3635 6.70646C14.5509 6.51894 14.6562 6.26463 14.6562 5.99946C14.6562 5.7343 14.5509 5.47999 14.3635 5.29246Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpArrowUpBold);
export default __webpack_public_path__ + "static/media/ep_arrow-up-bold.28b33c73dc6fd3ae494911ebc0a3d2e5.svg";
export { ForwardRef as ReactComponent };